/**
 * @generated SignedSource<<c8bce98d35cb8fa478951524ce82484d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WAWeatherSettingsSearchQuery$variables = {
  query: string;
};
export type WAWeatherSettingsSearchQuery$data = {
  readonly searchPlaces: ReadonlyArray<{
    readonly displayName: string | null;
    readonly formattedAddress: string | null;
    readonly id: string;
  }>;
};
export type WAWeatherSettingsSearchQuery = {
  response: WAWeatherSettingsSearchQuery$data;
  variables: WAWeatherSettingsSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "Place",
    "kind": "LinkedField",
    "name": "searchPlaces",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "formattedAddress",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WAWeatherSettingsSearchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WAWeatherSettingsSearchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8cd3e6d2e1617d2c9266ea48ccd408c",
    "id": null,
    "metadata": {},
    "name": "WAWeatherSettingsSearchQuery",
    "operationKind": "query",
    "text": "query WAWeatherSettingsSearchQuery(\n  $query: String!\n) {\n  searchPlaces(query: $query) {\n    id\n    displayName\n    formattedAddress\n  }\n}\n"
  }
};
})();

(node as any).hash = "30164949278436da9b9bb0240defbc00";

export default node;
